import store from '@/store';
import {Route} from 'vue-router';
import {NextMiddleware} from '@/types';

export default function(to: Route, from: Route, next: NextMiddleware) {
  if (store.getters['auth/isAuthenticated']) {
    next({
      name: 'home',
      query: {
        logged_in: '1',
      },
    });
  } else {
    next();
  }
}
